const AccountRecantRouter = [
  {
    path     : '/account/recant',
    component: () => import ('@/app/layout/view/layout-recant-default.vue'),
    redirect : '/account/recant/account-recant-withdrawal',
    children : [
      {
        path     : 'account-recant-withdrawal',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/recant/view/account-recant-withdrawal.vue'),
      },
      {
        path     : 'account-recant-withdrawal-agree',
        meta     : {routerGuard: true},
        component: () => import('@/app/account/recant/view/account-recant-withdrawal-agree.vue'),
      }
    ]
  }
];

export default AccountRecantRouter;
